export default "__VITE_ASSET__6153zEsW__"